import { createFileRoute } from '@tanstack/react-router';
import { MovementLedgerReport } from '../../../features/reports/screens/MovementLedgerReport';

/** Owned by G25. Report #2 + register "the ledger browser". */
export const Route = createFileRoute('/_authenticated/reports/movements')({
  component: MovementLedgerReport,
});
